module.exports = __webpack_public_path__ + "img/success-top.ff7c389.png";